import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/dashboard' },
    { path: '/login', name: 'login', component: () => import('@/pages/LoginPage.vue') },
    // Signed in, but no customer yet: none in the CRM, or several to pick from.
    {
      path: '/no-account',
      name: 'no-account',
      component: () => import('@/pages/NoAccountPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/select-customer',
      name: 'select-customer',
      component: () => import('@/pages/SelectCustomerPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/',
      component: () => import('@/components/AppShell.vue'),
      meta: { requiresAuth: true, requiresCustomer: true },
      children: [
        { path: 'dashboard', name: 'dashboard', component: () => import('@/pages/DashboardPage.vue') },
        { path: 'palvelut', name: 'palvelut', component: () => import('@/pages/PalvelutPage.vue') },
        { path: 'palvelut/:id', name: 'palvelu-detail', component: () => import('@/pages/PalveluDetailPage.vue') },
        { path: 'laskutus', name: 'laskutus', component: () => import('@/pages/LaskutusPage.vue') },
        { path: 'laskutus/:id', name: 'lasku-detail', component: () => import('@/pages/InvoiceDetailPage.vue') },
        { path: 'tuki', name: 'tuki', component: () => import('@/pages/TukiPage.vue') },
        { path: 'tilaus', name: 'tilaus', component: () => import('@/pages/TilausPage.vue') },
        // Legacy alias — /liittymat redirects to /palvelut for any bookmarks.
        { path: 'liittymat', redirect: '/palvelut' },
      ],
    },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/pages/NotFoundPage.vue') },
  ],
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  if (!auth.initialized) {
    await auth.bootstrap();
  }
  if (to.matched.some((r) => r.meta.requiresAuth) && !auth.user) {
    return { name: 'login', query: { next: to.fullPath } };
  }
  if (to.matched.some((r) => r.meta.requiresCustomer) && !auth.activeCustomer) {
    if (auth.customers.length === 0) return { name: 'no-account' };
    return { name: 'select-customer', query: { next: to.fullPath } };
  }
  if (to.name === 'login' && auth.user) {
    return { name: 'dashboard' };
  }
  return true;
});
